document.addEventListener('change', function (event) {
  if (event.target && event.target.matches('[data-auto-submit]')) {
    event.target.form.submit();
  }
});

document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[data-scroll-to]');
  if (!trigger) return;

  const target = document.querySelector(trigger.dataset.scrollTo);
  if (target) {
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
});

(function () {
  function initProductGalleries() {
    const galleries = document.querySelectorAll('[data-product-gallery]');
    if (!galleries.length) return;

    galleries.forEach(function (gallery) {
      const mainImage = gallery.querySelector('.product-gallery__main-image');
      const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
      const prev = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      if (!mainImage || thumbs.length < 2) return;

      let activeIndex = Math.max(0, thumbs.findIndex(function (thumb) {
        return thumb.classList.contains('is-active');
      }));

      const imageCache = new Map();

      function preloadImage(src) {
        if (!src) return null;
        if (imageCache.has(src)) return imageCache.get(src);

        const image = new Image();
        image.decoding = 'async';
        image.loading = 'eager';
        image.src = src;

        const ready = image.decode
          ? image.decode().catch(function () {})
          : new Promise(function (resolve) {
            image.onload = resolve;
            image.onerror = resolve;
          });

        const cached = { image: image, ready: ready };
        imageCache.set(src, cached);
        return cached;
      }

      function preloadNeighbors(index) {
        [index, index + 1, index - 1].forEach(function (itemIndex) {
          const thumb = thumbs[(itemIndex + thumbs.length) % thumbs.length];
          if (thumb && thumb.dataset.gallerySrc) {
            preloadImage(thumb.dataset.gallerySrc);
          }
        });
      }

      function applyThumbImage(thumb) {
        const src = thumb.dataset.gallerySrc;
        if (!src) return false;

        preloadImage(src);
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = src;
        mainImage.alt = thumb.dataset.galleryAlt || mainImage.alt || '';
        return true;
      }

      function setActive(index) {
        activeIndex = (index + thumbs.length) % thumbs.length;
        const thumb = thumbs[activeIndex];
        if (!applyThumbImage(thumb)) return;
        preloadNeighbors(activeIndex);

        thumbs.forEach(function (item, itemIndex) {
          const isActive = itemIndex === activeIndex;
          item.classList.toggle('is-active', isActive);
          if (isActive) {
            item.setAttribute('aria-current', 'true');
          } else {
            item.removeAttribute('aria-current');
          }
        });
      }

      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () {
          setActive(index);
        });
      });

      if (prev) {
        prev.addEventListener('click', function () {
          setActive(activeIndex - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          setActive(activeIndex + 1);
        });
      }

      preloadNeighbors(activeIndex);
      window.setTimeout(function () {
        thumbs.forEach(function (thumb) {
          preloadImage(thumb.dataset.gallerySrc);
        });
      }, 300);
    });
  }

  function initProductOptions() {
    const pickers = document.querySelectorAll('[data-product-options]');
    if (!pickers.length) return;

    pickers.forEach(function (picker) {
      const form = picker.closest('form');
      if (!form) return;

      const select = form.querySelector('[data-variant-select]');
      const variantJson = form.querySelector('[data-product-variants-json]');
      const addButton = form.querySelector('button[name="add"]');
      const status = form.querySelector('[data-variant-status]');
      if (!select || !variantJson) return;

      let variants = [];
      try {
        variants = JSON.parse(variantJson.textContent || '[]');
      } catch (error) {
        return;
      }

      function getSelectedOptions() {
        const options = [];
        picker.querySelectorAll('[data-option-position]').forEach(function (control) {
          if (control.type === 'radio' && !control.checked) return;
          options[Number(control.dataset.optionPosition)] = control.value;
        });
        return options;
      }

      function findVariant(options) {
        return variants.find(function (variant) {
          return variant.options.every(function (option, index) {
            return option === options[index];
          });
        });
      }

      function setOptionValue(position, value) {
        picker.querySelectorAll('[data-option-position="' + position + '"]').forEach(function (control) {
          if (control.type === 'radio') {
            control.checked = control.value === value;
          } else {
            control.value = value;
          }
        });
      }

      function firstMatchingVariant(options) {
        for (let prefixLength = options.length - 1; prefixLength >= 0; prefixLength -= 1) {
          const variant = variants.find(function (candidate) {
            return candidate.options.slice(0, prefixLength).every(function (option, index) {
              return option === options[index];
            });
          });
          if (variant) return variant;
        }
        return variants[0] || null;
      }

      function ensureValidSelection() {
        let selectedOptions = getSelectedOptions();
        if (findVariant(selectedOptions)) return selectedOptions;

        const fallbackVariant = firstMatchingVariant(selectedOptions);
        if (!fallbackVariant) return selectedOptions;

        fallbackVariant.options.forEach(function (option, index) {
          setOptionValue(index, option);
        });
        return getSelectedOptions();
      }

      function syncOptionAvailability(selectedOptions) {
        picker.querySelectorAll('[data-option-position]').forEach(function (control) {
          const position = Number(control.dataset.optionPosition);

          function isAvailableValue(value) {
            return variants.some(function (variant) {
              return variant.options.every(function (option, index) {
                if (index === position) return option === value;
                if (index > position) return true;
                return !selectedOptions[index] || option === selectedOptions[index];
              });
            });
          }

          if (control.tagName === 'SELECT') {
            Array.from(control.options).forEach(function (option) {
              option.disabled = !isAvailableValue(option.value);
            });
            return;
          }

          const isAvailable = isAvailableValue(control.value);
          control.disabled = !isAvailable;
          const chip = control.closest('.product-option-chip');
          if (chip) chip.classList.toggle('is-disabled', !isAvailable);
        });
      }

      function syncVariant() {
        const selectedOptions = ensureValidSelection();
        syncOptionAvailability(selectedOptions);
        const variant = findVariant(selectedOptions);

        if (!variant) {
          if (addButton) {
            addButton.disabled = true;
            addButton.textContent = 'Unavailable';
          }
          if (status) {
            status.textContent = 'This specification is not currently available.';
          }
          return;
        }

        select.value = String(variant.id);
        select.dispatchEvent(new Event('change', { bubbles: true }));

        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }

        if (status) {
          status.textContent = variant.available
            ? 'Selected: ' + variant.title
            : 'Selected: ' + variant.title + ' - currently unavailable';
        }
      }

      picker.addEventListener('change', syncVariant);
      syncVariant();
    });
  }

  function injectProductTrustFallback() {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    if (document.querySelector('.product-trust-list')) return;

    const purchaseCard = document.querySelector('.product-purchase-card');
    if (!purchaseCard) return;

    const trust = document.createElement('div');
    trust.className = 'product-trust-list product-trust-list--standalone';
    trust.setAttribute('aria-label', 'LASHMAITRE product trust information');
    trust.innerHTML = [
      '<span>Secure checkout with PayPal now; card payments will be added after Airwallex approval.</span>',
      '<span>Global shipping support for retail, sample, wholesale and private label orders.</span>',
      '<span>Confirm samples, curl, thickness, length mix and packaging before bulk production.</span>',
      '<span>Returns depend on hygiene condition and published policy; support: info@lashmaitre.com.</span>',
    ].join('');

    purchaseCard.insertAdjacentElement('afterend', trust);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initProductGalleries();
      initProductOptions();
      injectProductTrustFallback();
    });
  } else {
    initProductGalleries();
    initProductOptions();
    injectProductTrustFallback();
  }
})();

(function rewriteCachedProductLinks() {
  var legacyPath = '/products/8d-promade-fans-tray-500-fans';
  var currentPath = '/products/8d-promade-lash-fans-tray-500-fans';

  function rewrite() {
    document.querySelectorAll('a[href*="' + legacyPath + '"]').forEach(function (link) {
      link.href = link.href.replace(legacyPath, currentPath);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewrite);
  } else {
    rewrite();
  }
})();

(function () {
  function initScrollStories() {
    const stories = document.querySelectorAll('[data-scroll-story]');
    if (!stories.length) return;

    stories.forEach(function (story) {
      const steps = Array.from(story.querySelectorAll('[data-story-step]'));
      const frames = Array.from(story.querySelectorAll('[data-story-frame]'));
      const metric = story.querySelector('[data-story-metric]');
      if (!steps.length) return;

      let activeIndex = -1;
      let rafId = null;

      function setActive(index) {
        const safeIndex = Math.max(0, Math.min(index, steps.length - 1));
        if (safeIndex === activeIndex) return;

        activeIndex = safeIndex;
        const progress = ((safeIndex + 1) / steps.length) * 100;
        story.dataset.active = String(safeIndex);
        story.style.setProperty('--story-progress', progress + '%');

        steps.forEach(function (step, stepIndex) {
          step.classList.toggle('is-active', stepIndex === safeIndex);
        });

        frames.forEach(function (frame, frameIndex) {
          frame.classList.toggle('is-active', frameIndex === safeIndex);
        });

        if (metric && steps[safeIndex] && steps[safeIndex].dataset.metric) {
          metric.textContent = steps[safeIndex].dataset.metric;
        }
      }

      function updateByScrollPosition() {
        rafId = null;

        const storyRect = story.getBoundingClientRect();
        if (storyRect.bottom < 0 || storyRect.top > window.innerHeight) return;

        const anchor = window.innerHeight * 0.5;
        let closestIndex = 0;
        let closestDistance = Infinity;

        steps.forEach(function (step, stepIndex) {
          const rect = step.getBoundingClientRect();
          const center = rect.top + rect.height / 2;
          const distance = Math.abs(center - anchor);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = stepIndex;
          }
        });

        setActive(closestIndex);
      }

      function requestUpdate() {
        if (rafId) return;
        rafId = window.requestAnimationFrame(updateByScrollPosition);
      }

      setActive(0);
      requestUpdate();

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          function (entries) {
            if (entries.some(function (entry) { return entry.isIntersecting; })) {
              requestUpdate();
            }
          },
          {
            rootMargin: '12% 0px 12% 0px',
            threshold: 0
          }
        );

        observer.observe(story);
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(requestUpdate).catch(function () {});
      }

      window.addEventListener('load', requestUpdate, { once: true });
      steps.forEach(function (step) {
        step.addEventListener('mouseenter', function () {
          setActive(Number(step.dataset.storyStep || 0));
        });
        step.addEventListener('focusin', function () {
          setActive(Number(step.dataset.storyStep || 0));
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollStories);
  } else {
    initScrollStories();
  }
})();
